import { IMachineDailyWorks } from 'app/models';
import { Component, Input, OnInit } from '@angular/core';
import { DataWorkService } from 'app/services/data-work/data.work.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-machine-daily-works',
  templateUrl: './machine.daily.works.component.html',
  styleUrls: ['./machine.daily.works.component.scss'],
})
export class MachineDailyWorksComponent implements OnInit {
  @Input()
  machineId: number | null = null;

  machineDailyWorks: IMachineDailyWorks[] = [];

  constructor(private readonly dataWorkService: DataWorkService) {}

  ngOnInit(): void {
    if (this.machineId) {
      this.dataWorkService
        .getDailyJobsByMachine(this.machineId)
        .pipe(
          map((response) =>
            response.map(({ date, job }) => ({
              date: date.split(' ')[0],
              time: date.split(' ')[1],
              job,
            }))
          )
        )
        .subscribe(
          (machineDailyJobs) => {
            this.machineDailyWorks = machineDailyJobs;
          },
          () => console.error
        );
    }
  }
}
